<template>
  <div class="mod-joylearning__offringlist}">
    <div class="pkg-search-box">
      <el-form class="pkg-content" label-width="auto"
               :rules="rulesForm"
               ref="dataListAll"
               :model="dataListAll"
               label-position="left">
        <el-row class="margb10">
          <el-col :span="7">
            <el-form-item label="职位"
                          prop="jobId"
                          class="search-item">
              <el-select v-model="dataListAll.jobId"
                         clearable
                         :disabled="isEdit"
                         :placeholder="$t('user.select')"
                          @change="jobIdChange">
                <el-option v-for="(item,index) in keyPositionArr"
                           :key="index"
                           :label="item.positionCode + '-' +item.positionName"
                           :value="item.positionId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="能力项"
                          prop="parentId"
                          class="search-item">
              <el-select v-model="dataListAll.parentId"
                         clearable
                         :disabled="isEdit"
                         placeholder="请选择"
                         @change="parentAllChange">
                <el-option
                        v-for="item in parentALl"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="子能力项"
                          class="search-item">
              <el-select v-model="dataListAll.childId"
                         clearable
                         :disabled="isEdit"
                         placeholder="请选择">
                <el-option
                        v-for="item in parentChildALl"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- ---->
      </el-form>
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon">
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pkg-content">
      <div class="search">
        <el-button
                v-show = !isEdit
                type="primary"
                @click="onAdd()">新增
        </el-button>
        <el-button
                v-show= !isEdit
                type="primary"
                @click="onDeleteAll()">删除
        </el-button>
      </div>
      <!-- 表头动态展示 -->
      <el-table ref="multipleTable"
                :data="dataList"
                border
                :row-style="{height:48+'px'}"
                :cell-style="{padding:0+'px'}">

        <!--  课程名称  -->
        <el-table-column prop="course"
                         label="课程名称"
                         header-align="center"
                         align="center"></el-table-column>
        <!--是否必修-->
        <el-table-column prop="required"
                         label="是否必修"
                         header-align="center"
                         align="left">
          <template slot-scope="scope">
<!--            dataList[scope.$index].required-->
            <el-select v-model="dataList[scope.$index].required" placeholder="请选择" @change="requiredChange(scope)">
              <el-option
                      v-for="item in required"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <!--学习对象类型-->
        <el-table-column label="课程对象类型"
                         prop="courseKind"
                         header-align="left"
                         align="left"></el-table-column>

        <!--操作 -->
        <el-table-column :label="$t('offering.operation')"
                         fixed="right"
                         header-align="center"
                         align="center"
                         width="150">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" v-if="!isEdit" @click="deleteRow(scope.$index, dataList)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-row style="float:right; margin-bottom: 60px;">
          <el-col :span="16">
            <div class="grid-content"/>
          </el-col>
          <el-button @click="onSubmit"
                     v-if="!isEdit"
                     type="primary">{{ $t("course.save") }}
          </el-button>
          <el-button @click="onUpdate"
                     v-if="isEdit"
                     type="primary">{{ $t("course.save") }}
          </el-button>
          <ZElButton @click="cancel">{{ $t("course.cancel") }}</ZElButton>
        </el-row>
      </div>
    </div>

    <el-dialog
            :modal="true" width="1100px"
            :visible.sync="dialogTableVisible"
            :before-close="handleClose">
      <div style="height: 650px;">
        <courseds
                @inputss="inputss"
                ref="selCourseDialog"
                :courseInfoList="dataList"></courseds>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import courseds from './selCourse'
  import ZElButton from '../../learning/common/button/index'

  export default {
    components: {
      courseds,
      ZElButton
    },
    name: "courseAbiletyEdit",
    data() {
      return {
        dialogTableVisible: false,// 弹出框

        isEdit: false , // 是否可以编辑

        dataList: [],
        compulsoryValue: '1',
        required:[
          {
            value: '1',
            label: '必修'
          }, {
            value: '0',
            label: '选修'
          }
        ],


        dataListAll: {
          jobId: '',//职位id
          parentId: '',//能力项id
          childId: '',//能力子项id
          courseInfoList: [
            {
              conditionCourseId: 10340, // 必须返回int类型
              course: 'M_TE_FF_CN_0097 - MINI 3级-专家技师认证',
              required: '2',
              courseKind: '面授课'
            },
            {
              conditionCourseId: 10340, // 必须返回int类型
              course: 'M_TE_FF_CN_0097 - MINI 3级-专家技师认证',
              required: '2',
              courseKind: '面授课'
            },
          ]
        },

        keyPositionArr: [],
        parentALl: [],
        parentChildALl: [],

        rulesForm: {
          jobId: [
            {required: true, message: '请选择职位', trigger: 'change'}
          ],
          parentId: [
            {required: true, message: '请选择能力项', trigger: 'change'}
          ],
        },
      }
    },


    created() {
      this.init()
    },

    mounted() {
      this.$eventHub.$on('showCourseAbilityAdd', (data) => {
        this.recoveryData()
        this.init()
      })
      this.$eventHub.$on('showCourseAbilityEdit', (data) => {
        this.getCourseDetail()
      })
    },
    methods: {

      // 初始化
      init() {
        console.log('init')
        console.log(this.$route.query.id)

        // 职位
        this.$request
          .get('/sys/commposition/keyPosition', {})
          .then((res, total, code, data) => {
            console.log('kekyPosition')
            console.log(data)
            this.keyPositionArr = data.data
          })
          .catch((err) => {
            console.log(err)
          })

        this.getCourseDetail()

      },

      // 恢复
      recoveryData(){
        this.dataList = []
        this.isEdit = false
        this.$set(this.dataListAll,'jobId','')
        this.$set(this.dataListAll,'parentId','')
        this.$set(this.dataListAll,'childId','')
        this.$set(this.dataListAll,'courseInfoList',[])
        this.$refs['dataListAll'].resetFields();
      },

      // 获取课程相关数据
      getCourseDetail(){
        if (this.$route.query.id !== '' && this.$route.query.id !== undefined && this.$route.query.id !== null) {
          this.isEdit = true
          this.$request
            .get('/actionplan/competencyToCourse/queryCompToCourseDetail?id=' + this.$route.query.id, {})
            .then((res, total, code, data) => {
              console.log('queryCompetencyModelInfo')
              console.log(data)
              //this.dataListAll = data.data
              this.dataList = data.data.courseInfoList
              this.dataListAll.jobId = data.data.jobName
              this.dataListAll.parentId = data.data.parentName
              this.dataListAll.childId = data.data.childName
            })
            .catch((err) => {
              console.log(err)
            })
        }
      },

      // 职位值改变后触发
      jobIdChange(){
        if(this.dataListAll.jobId === null || this.dataListAll.jobId === undefined || this.dataListAll.jobId === ''){
          this.parentALl = []
          this.dataListAll.parentId = ''
          this.parentChildALl = []
          this.dataListAll.childId = ''
        }else {
          // 能力项
          this.$request
            .get('/actionplan/competencyModel/queryCompetencyModelInfoByJobId', {jobId: this.dataListAll.jobId})
            .then((res, total, code, data) => {
              console.log('queryCompetencyModelInfo')
              console.log(data)
              // name 名字
              // id: "2",
              this.parentALl = data.data
            })
            .catch((err) => {
              console.log(err)
            })
        }
      },

      // 能力项改值触发
      parentAllChange() {
        console.log('parentAllChange')
        console.log(this.dataListAll.parentId)
        // 重置当前子能力项的值
        this.parentChildALl = []
        this.dataListAll.childId = ''
        if (this.dataListAll.parentId !== '' && this.dataListAll.parentId !== undefined && this.dataListAll.parentId !== null) {
          this.$request
            .get('/actionplan/competencyModel/queryCompetencyModelInfoByJobIdAndParentId', {jobId:this.dataListAll.jobId,parentId: this.dataListAll.parentId})
            .then((res, total, code, data) => {
              console.log('queryCompetencyModelInfo')
              console.log(data)
              // name 名字
              // id: "2",
              this.parentChildALl = data.data
            })
            .catch((err) => {
              console.log(err)
            })
        }

      },

      // 保存按钮处理
      onSubmit() {
        console.log('保存')
        console.log(this.dataList)
        this.dataListAll.courseInfoList = this.dataList
        console.log(this.dataListAll)

        this.$refs['dataListAll'].validate((valid) => {
          console.log('dataList')
          console.log(valid)
          if (valid) {
            this.$request
              .post('/actionplan/competencyToCourse/saveCourseCompetencyModel', this.dataListAll)
              .then((res, total, code, data) => {
                console.log('saveCourseCompetencyModel')
                console.log(data)
                if(data.code === 1){
                  this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                  })
                  this.tabRemove()
                }else{
                  this.$message.error(data.msg)
                }
              })
              .catch((err) => {
                console.log(err)
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });


      },

      //修改接口
      onUpdate(){
        console.log('onUpdate')
        console.log('修改')
        console.log(this.dataList)
        this.dataListAll.courseInfoList = this.dataList
        console.log(this.dataListAll)
        this.$request
          .post('/actionplan/competencyToCourse/updateCourseCompetencyModel', this.dataListAll)
          .then((res, total, code, data) => {
            console.log('updateCourseCompetencyModel')
            console.log(data)
            if(data.code === 1){
              this.$message.success("修改成功")
              this.tabRemove()
            }
          })
          .catch((err) => {
            console.log(err)
          })

      },

      // 选择课程关闭
      handleClose(){
        console.log('handleClose initMethods')
        this.dialogTableVisible = false
        this.$refs.selCourseDialog.initMethods()
      },


      // 删除当前页面
      /* tabRemove () {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
        }
      }, */
      // 添加课程
      onAdd() {
        this.dialogTableVisible = true

      },
      // 全部删除
      onDeleteAll() {

        if(this.dataList.length === 0){
          console.log('onDeleteAll')
        }else {
          this.$confirm(this.$t('prompt.info', {'handle': this.$t('delete')}), this.$t('prompt.title'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel')
          }).then(() => {
            this.dataList = []
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      // 行删除
      deleteRow(index, rows) {
        this.$confirm(this.$t('prompt.info', {'handle': this.$t('delete')}), this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }).then(() => {
          rows.splice(index, 1);
        }).catch((err) => {
          console.log(err)
        })
      },
      // 勾选后回显
      inputss: function (data) {
        console.log('inputss')
        console.log(data)

        data.forEach(row => {
          this.dataList.push({
            conditionCourseId: row.id,
            course: row.course,
            courseKind: row.courseKind,
            required: '1'
          })
        })

        this.dialogTableVisible = false
      },

      // 取消按钮
      cancel() {
        this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tabRemove()
        }).catch((err) => {
          console.log(err)
        })
      },
      // 删除当前页面
      tabRemove() {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name})
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../css/pkg-styles.css";

  .aui-wrapper .el-date-editor .el-range-separator {
    width: 30px;
  }

  .jieshu .el-form-item__content {
    width: 94.5%;
  }

  .kaishi .el-form-item__content {
    width: 111%;
  }

  .el-row {
    margin-bottom: 0px;
  }

  #container {
    display: -webkit-flex;
  }

  .el-date-editor.el-input {
    width: 150px;
  }

  .search-item {
    width: 94% !important;
    min-width: 290px;
  }

  .search {
    height: 50px;
  }

  .wrapper-div {
    .el-dialog__title {
      text-align: center;
      display: block;
    }
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
   .search-item .el-form-item__content {
    margin-left: 96px !important;
  }
</style>
